// shellKeys: when a key belongs to the page, not to the shell.
//
// The shell binds a few chords of its own (⌘Z undoes a rename or a move, ⌘C
// picks up the folder under the pointer). They are for the directory. Anywhere a
// person is typing, the same chords mean what they always mean: undo the last
// word, copy the selected words. The notion-like editor is a contenteditable,
// not an input, so a guard that only knew INPUT and TEXTAREA let ⌘Z undo a
// rename the person made ten minutes ago, in another folder, while they were
// writing a sentence.

/** true when typing here is typing: a field, a select, or anything editable
 *  (the document editor, a nested editable inside it). */
export function isTypingTarget(target: EventTarget | null): boolean {
  const el = target as (Partial<HTMLElement> & { closest?: (s: string) => Element | null }) | null;
  if (!el) return false;
  const tag = typeof el.tagName === "string" ? el.tagName : "";
  if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return true;
  if (el.isContentEditable) return true;
  try {
    return !!el.closest?.("[contenteditable]:not([contenteditable='false'])");
  } catch {
    return false;
  }
}

/** true when the shell should leave this key press alone: someone already
 *  handled it (the editor's own ⌘Z calls preventDefault), or it is typing. */
export function shellShouldIgnoreKey(e: { defaultPrevented: boolean; target: EventTarget | null }): boolean {
  return e.defaultPrevented || isTypingTarget(e.target);
}
